export default {
    comparisonOptions: {
        leftType: "constantValue",
        rightType: "constantValue",
        rightValue: "",
        operator: "equals"
    },
    conditionState: true,
    type: "trueValue",
    operator: "equals"
}